// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yTCRX","newExpiryDate":"styles_newExpiryDate__1UEUV","footer":"styles_footer__2W8pA"};